import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { ListingProgressV2Status } from '@app/models/enums'

export enum TriStateCheckboxState {
  Checked = 'Checked',
  Indeterminate = 'Indeterminate',
  Empty = 'Empty',
}

interface ICheckBoxProps {
  children?: React.ReactNode
  className?: string
  value: ListingProgressV2Status
  onChange: (newValue: ListingProgressV2Status) => any
  style?: React.CSSProperties
  tabIndex?: number
}

export default class ListingProgressV2StatusSelect extends React.Component<
  ICheckBoxProps
> {
  shouldComponentUpdate(
    nextProps: Readonly<ICheckBoxProps>,
    nextState: Readonly<{}>,
    nextContext: any,
  ): boolean {
    return this.props.value !== nextProps.value
  }

  render() {
    const iconName =
      this.props.value === ListingProgressV2Status.Incomplete
        ? 'circle'
        : this.props.value === ListingProgressV2Status.Complete
        ? 'check-circle'
        : 'times-circle'

    const nextValue =
      this.props.value === ListingProgressV2Status.Incomplete
        ? ListingProgressV2Status.Complete
        : this.props.value === ListingProgressV2Status.Complete
        ? ListingProgressV2Status.Ignore
        : ListingProgressV2Status.Incomplete

    return (
      <div className='mb-2'>
        <label
          tabIndex={this.props.tabIndex}
          role='button'
          onClick={(e) => {
            e.preventDefault()
            this.props.onChange(nextValue)
          }}
          style={this.props.style}
        >
          <FontAwesomeIcon icon={['fal', iconName]} />
          <span
            style={{
              textDecoration:
                ListingProgressV2Status.Ignore === this.props.value
                  ? 'line-through'
                  : '',
              userSelect: 'none',
            }}
            className='pl-3 my-1'
          >
            {this.props.children}
          </span>
        </label>
      </div>
    )
  }
}
